export default "__VITE_ASSET__DmCVxrgL__"